import * as React from "react"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TablePagination from "@mui/material/TablePagination"
import TableRow from "@mui/material/TableRow"
import _ from "lodash"
import { Container } from "@mui/material"

interface DriverProfileTableProps {
  data: any[]
}

interface Column {
  id: string
  label: string
  minWidth?: number
  align?: "right"
}

const columns: readonly Column[] = [
  { id: "rails_id", label: "Driver Id", minWidth: 170 },
  { id: "is_driver_allowed_deliver_alcohol", label: "Is Allowed Deliver Alcohol", minWidth: 100 },
  { id: "is_driver_allowed_deliver_other_restricted_products", label: "Is Allowed Deliver Other RP", minWidth: 100 },
]

const createData = (row: any) => {
  return {
    rails_id: row.rails_id,
    is_driver_allowed_deliver_alcohol: row.is_driver_allowed_deliver_alcohol,
    is_driver_allowed_deliver_other_restricted_products: row.is_driver_allowed_deliver_other_restricted_products,
  }
}

/**
 * Quick standalone table to render Alcohol/RP Attributes for Driver Profiles
 * @param props DriverProfileTableProps
 */
export const DriverProfileTable: React.FC<DriverProfileTableProps> = (props: DriverProfileTableProps) => {
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const data = props.data

  const rows = _.map(data, (row) => {
    return createData(row)
  })
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <Container>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.rails_id}>
                  {columns.map((column) => {
                    const value = _.get(row, column.id)
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {_.toString(value)}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Container>
  )
}
